/**
 * Behavioural profile mapping helpers (frontend mirror of backend/behavioural_utils.py).
 */

export const BEHAVIOURAL_TAG_MAP = {
  behavioural_decisions: {
    data_analysis: 'Analytical',
    stakeholder_impact: 'Empathic',
  },
  behavioural_processing: {
    practical_proven: 'Pragmatic',
    new_ideas: 'Innovative',
  },
  behavioural_working: {
    structured_timelines: 'Structured',
    flexible_adaptive: 'Flexible',
  },
  behavioural_collaboration: {
    think_aloud: 'Verbal',
    reflect_first: 'Reflective',
  },
};

export const AXIS_LABELS = {
  behavioural_decisions: 'Decisions',
  behavioural_processing: 'Processing',
  behavioural_working: 'Working',
  behavioural_collaboration: 'Collaboration',
};

// Tailwind classes per trait tag (consistent across the platform)
export const TAG_COLORS = {
  Analytical: 'bg-indigo-50 text-indigo-700 border-indigo-100',
  Empathic: 'bg-pink-50 text-pink-700 border-pink-100',
  Pragmatic: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  Innovative: 'bg-amber-50 text-amber-700 border-amber-100',
  Structured: 'bg-sky-50 text-sky-700 border-sky-100',
  Flexible: 'bg-violet-50 text-violet-700 border-violet-100',
  Verbal: 'bg-rose-50 text-rose-700 border-rose-100',
  Reflective: 'bg-slate-100 text-slate-700 border-slate-200',
};

export function getTraitTags(profile) {
  if (!profile) return [];
  const tags = [];
  for (const [axis, mapping] of Object.entries(BEHAVIOURAL_TAG_MAP)) {
    const v = profile[axis];
    if (v && mapping[v]) tags.push(mapping[v]);
  }
  return tags;
}

export const BEHAVIOURAL_QUESTIONS = [
  { key: 'behavioural_decisions', q: 'When making decisions in complex projects, I typically:', options: [
    ['data_analysis', 'Prioritise data and objective analysis'], ['stakeholder_impact', 'Consider stakeholder impact and relationships']] },
  { key: 'behavioural_processing', q: 'When processing information I prefer to:', options: [
    ['practical_proven', 'Focus on practical details and proven approaches'], ['new_ideas', 'Explore new ideas and future possibilities']] },
  { key: 'behavioural_working', q: 'When working on a project, I:', options: [
    ['structured_timelines', 'Prefer structure, timelines, and clear decisions'], ['flexible_adaptive', 'Stay flexible and adapt as new information emerges']] },
  { key: 'behavioural_collaboration', q: 'In collaborative environments, I:', options: [
    ['think_aloud', 'Think out loud and engage actively in discussions'], ['reflect_first', 'Reflect first and contribute thoughtfully']] },
];

